import LandingPage from './LandingPage/LandingPage';
import SRELandingPage from './SRELandingPage/SRELandingPage';
import Accounts from './Accounts/Accounts';
import Policies from './Policies/Policies';
import Activities from './Activities/Activities';
import Analytics from './Analytics/Analytics';
import AccountDetails from './Accounts/AccountDetails/AccountDetails';
import PolicyDetails from './Policies/PolicyDetails/PolicyDetails';
import NewQuoteAccountSearch from './NewQuote/NewQuoteAccountSearch';
import NewQuotePage from './NewQuote/NewQuote/NewQuotePage';
import SearchResults from './SearchResults/SearchResults';
import QuoteDetails from './QuoteDetails/QuoteDetails';
import Renewal from './Renewal/Renewal';
import Endorsement from './Endorsement/Endorsement';
import Cancellation from './Cancellation/Cancellation';
import AccountBillingAndPayment from './Accounts/BillingAndPayment/BillingAndPayment';
import MakePayment from './Accounts/BillingAndPayment/MakePayment/MakePayment';
import ContactUnderwriter from './ContactUnderwriter/ContactUnderwriter';
import PaymentConfirmation from './Accounts/BillingAndPayment/PaymentConfirmation/PaymentConfirmation';
import MenuBarComponent from './Components/MenuBar/MenuBarComponent';
import PageHeaderComponent from './Components/PageHeader/PageHeaderComponent';
import ContactRoles from './Components/ContactRoles/ContactRoles';
import gatewayMessages from './gateway.messages';
import accountMessages from './Accounts/Accounts.messages';
import PolicyDetailsComponent from './Components/PolicyCommonDetails/PolicyCommonDetails';
import CoverageTable from './Components/CoverageTableComponent/CoverageTable';
import AddressComponent from "./Components/Address/AddressComponent";
import CanceledPolicyComponent from './Components/CanceledPolicyComponent/CanceledPolicyComponent';
import AccountContactSearchComponent from "./Components/AccountContactSearchComponents/AccountContactSearchComponent";
import BrokerBills from './BrokerBills/BrokerBills';
import DirectBills from './DirectBills/DirectBills';
import PaymentMethodComponent from "./Components/PaymentMethodComponent/PaymentMethodComponent";
import PolicyCommercialPropertyInfoComponent from "./Policies/Summary/bop/PolicyCommericalPropertyInfoComponent/PolicyCommericalPropertyInfoComponent";
import PolicyLiabilityComponent from './Components/PolicyLiabilityComponent/PolicyLiabilityComponent';

const producerEngageComponentMap = {
    ContactRoles: { component: 'ContactRoles' },
};

const producerEngageAdditionalComponents = {
    ContactRoles,
};

export { default as summaryMessages } from './Endorsement/Summary/Summary.messages';

export {
    LandingPage ,
    SRELandingPage as default,
    Accounts,
    Policies,
    Activities,
    Analytics,
    AccountDetails,
    PolicyDetails,
    NewQuoteAccountSearch,
    NewQuotePage,
    SearchResults,
    QuoteDetails,
    Renewal,
    Endorsement,
    Cancellation,
    AccountBillingAndPayment,
    MakePayment,
    ContactUnderwriter,
    PaymentConfirmation,
    MenuBarComponent,
    PageHeaderComponent,
    ContactRoles,
    producerEngageComponentMap,
    producerEngageAdditionalComponents,
    gatewayMessages,
    accountMessages,
    PolicyDetailsComponent,
    CoverageTable,
    AddressComponent,
    CanceledPolicyComponent,
    AccountContactSearchComponent,
    BrokerBills,
    DirectBills,
    PaymentMethodComponent,
    PolicyCommercialPropertyInfoComponent,
    PolicyLiabilityComponent

};

export { default as AutomaticPaymentPolicyAffectedValueIterableComponent } from './Accounts/BillingAndPayment/AutomaticPaymentPolicyAffectedValueIterableComponent';
